import type { ComponentSize } from "./types";

export interface InstallOptions {
  size: ComponentSize;
  modalTo?: string;
  zIndex?: number;
}

let $GPLUS = {} as InstallOptions;

const setConfig = (option: InstallOptions): void => {
  $GPLUS = option;
};

const getConfig = (key: keyof InstallOptions): unknown => {
  return $GPLUS[key];
};

export { getConfig, setConfig };
